import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Heart, Link2, Inbox, GitBranch, Sparkles, Flame, User, ListChecks, HeartHandshake, BookHeart, Globe, Compass, ArrowRight } from 'lucide-react';

const CATEGORIES = [
  { key: 'core', items: [
    { k: 'give', icon: Heart, to: '/give' },
    { k: 'link', icon: Link2, to: '/give' },
    { k: 'inbox', icon: Inbox, to: '/inbox' },
    { k: 'echo', icon: GitBranch, to: '/chain' },
  ]},
  { key: 'community', items: [
    { k: 'gratitude', icon: Sparkles, to: '/dankbar' },
    { k: 'flow', icon: Heart, to: '/feed' },
    { k: 'streak', icon: Flame, to: '/feed' },
  ]},
  { key: 'profile', items: [
    { k: 'innerstes', icon: User, to: '/profile' },
    { k: 'lebensliste', icon: ListChecks, to: '/profile' },
    { k: 'herzensmenschen', icon: HeartHandshake, to: '/profile' },
    { k: 'publicProfile', icon: Globe, to: '/profile' },
  ]},
  { key: 'daily', items: [
    { k: 'tagebuch', icon: BookHeart, to: '/tagebuch' },
  ]},
];

export default function EntdeckenV2() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen text-[var(--text)]">
      <div className="max-w-3xl mx-auto px-4 py-6 sm:py-8 space-y-6" data-testid="entdecken-page">
        <div className="bg-white/85 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-sm">
          <h1 className="text-xl sm:text-2xl font-semibold flex items-center gap-2">
            <Compass size={22} className="text-[var(--primary)]" />
            {t('discover.title')}
          </h1>
          <p className="text-xs sm:text-sm text-[var(--muted)] mt-1">{t('discover.subtitle')}</p>
        </div>

        {CATEGORIES.map((cat) => (
          <div key={cat.key} className="space-y-2.5">
            <h2 className="text-sm font-semibold bg-white/70 backdrop-blur-sm rounded-full px-4 py-1.5 inline-block">{t(`discover.cat_${cat.key}`)}</h2>
            <div className="grid sm:grid-cols-2 gap-2.5">
              {cat.items.map(({ k, icon: Icon, to }) => (
                <button
                  key={k}
                  type="button"
                  onClick={() => navigate(to)}
                  data-testid={`discover-${k}`}
                  className="bg-white/85 backdrop-blur-sm rounded-2xl p-4 shadow-sm text-left flex items-start gap-3 hover:shadow-md hover:border-[var(--primary)]/30 border border-transparent transition-all group"
                >
                  <div className="w-9 h-9 rounded-full bg-[var(--primary)]/10 flex items-center justify-center flex-shrink-0">
                    <Icon size={16} className="text-[var(--primary)]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium">{t(`discover.f_${k}_title`)}</p>
                    <p className="text-xs text-[var(--muted)] leading-relaxed mt-0.5">{t(`discover.f_${k}_text`)}</p>
                  </div>
                  <ArrowRight size={14} className="text-[var(--muted)] opacity-0 group-hover:opacity-100 transition-opacity mt-1" />
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
